import React, {useEffect, useMemo, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {updateConfirmationRes} from '../../../../../../redux/ScheduleSlice';
import HugimCancellation from "./HugimCancellation";
import {APPOINTMENT, DEFAULTS} from "../../../../../../services/ConstHelper";
import usePermissions from "../../../../../../services/Permissions";
import {autoMessageTypes} from "../../ScheduleSettings/SettingsConfig";

const UpdateParticipants = (props) => {
    const { values, setFieldValue, isSingle, hideReason, isHug, isAppointment, debtInfo } = props;
    const scheduleCancelReasons = useSelector(state => state.box.box?.scheduleCancelReasons?.filter(reason => reason.active));
    const defaults = useSelector(state => state.box.box?.settings?.[DEFAULTS]);
    const autoActions = useSelector(state => state.box.box.auto_actions)

    const [defaultValues, setDefaultValues] = useState(null);
    const dispatch = useDispatch();
    const {has} = usePermissions()
    const allowReasonSelect = useMemo(() => !hideReason && (isHug || has('scheduleCancelReason')), [isHug, hideReason]);

    useEffect(() => {
        if(!defaultValues) {
            const hasCancelAppointmentAutoAction = isAppointment && autoActions?.filter(item => [autoMessageTypes.CANCEL_SESSION, autoMessageTypes.CANCEL_SESSION_STAFF_NOTIFY].includes(item.auto_actions.action) && item.active === 1 && item.session_type === APPOINTMENT)
            let defaultVals = {notify: values?.send_notifications ?? !hasCancelAppointmentAutoAction}
            if (allowReasonSelect && !isHug && scheduleCancelReasons && defaults?.schedule_cancel_reason_id) {
                if (scheduleCancelReasons.some(reason => reason.id === defaults?.schedule_cancel_reason_id)) {
                    defaultVals.reasonId = defaults?.schedule_cancel_reason_id ?? null
                }
            }
            setDefaultValues(defaultVals)
        }
    }, [defaults, scheduleCancelReasons, allowReasonSelect]);

    const onFieldChange = ({reasonId, notify, zeroDebt}) => {
        if (setFieldValue) { //for now only notify value is relevant from mass action (the only flow with formik)
            setFieldValue('send_notifications', notify)
        } else {
            dispatch(updateConfirmationRes({reasonId, sendNotifications: notify, ...(zeroDebt !== undefined && { zeroDebt })}))
        }
    }

    if(!defaultValues) return <></>

    return (
        <HugimCancellation isHug={!!isHug}
                           defaultValues={defaultValues}
                           onFieldChange={onFieldChange}
                           isSingle={isSingle}
                           hideReason={!allowReasonSelect}
                           isAppointment={!!isAppointment}
                           debtInfo={debtInfo}
        />
    );
};

export default UpdateParticipants;
